// extracted by mini-css-extract-plugin
module.exports = {"whiteOpacity":"rgba(235,235,235,.7803921569)","loading":"Button_loading__02CN1","disabled":"Button_disabled__xdHrG","btn":"Button_btn__rpJub"};